import bdServices125 from '../bd-services125'
import bdServices from '../bd-services'
const FormData = require('form-data')

const ResponsivasService = {}
const currentUrl = window.location.hostname


ResponsivasService.getResponsivas = async function (ubi, area) {
  const data = await bdServices.get(`/servidores/inventario/responsivas/getResponsivas.php?ubi=${ubi}&a=${area}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ResponsivasService.getResponsivas_users = async function (ubi, area) {
  const data = await bdServices.get(`/servidores/inventario/responsivas/getResponsivas_users.php?ubi=${ubi}&a=${area}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ResponsivasService.getResponsivas_tipo = async function (tipo) {
  const data = await bdServices.get(`/servidores/inventario/responsivas/getResponsivas_tipo.php?tipo=${tipo}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ResponsivasService.getIdResponsiva = async function (fechaI, fechaF) {
  const data = await bdServices.get(`/servidores/inventario/responsivas/getIdResponsiva.php?fechaI=${fechaI}&fechaF=${fechaF}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ResponsivasService.getItemsResponsivas = async function (idUser) {
  let formData = new FormData()
  formData.append('u', idUser)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/getItemsResponsivas.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ResponsivasService.getItems_Multiples = async function (idResponsiva) {
  let formData = new FormData()
  formData.append('nombreResp', idResponsiva)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/getItems_Multiples.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ResponsivasService.addResponsiva = async function (nombre, fechaReg, fechaResp, idUsuario, usuario, categoria, 
  ubicacion, area,idArticulo, puesto, codigoEmp, tipo, idEntrega, entrega) {
  let formData = new FormData()
  formData.append('nombre', nombre)
  formData.append('fechaReg', fechaReg)
  formData.append('fechaResp', fechaResp)
  formData.append('idUsuario', idUsuario)
  formData.append('usuario', usuario)
  formData.append('categoria', categoria)
  formData.append('ubicacion', ubicacion)
  formData.append('area', area)
  formData.append('idArticulo', idArticulo)
  formData.append('puesto', puesto)
  formData.append('codigoEmp', codigoEmp)
  formData.append('tipo', tipo)
  formData.append('idEntrega', idEntrega)
  formData.append('entrega', entrega)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/addResponsiva.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

ResponsivasService.updateResponsiva = async function (id, nombre, fechaResp, idUsuario, usuario, categoria, ubicacion, area, idArticulo, puesto, codigoEmp, tipo) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('nombre', nombre)
  formData.append('fechaResp', fechaResp)
  formData.append('idUsuario', idUsuario)
  formData.append('usuario', usuario)
  formData.append('categoria', categoria)
  formData.append('ubicacion', ubicacion)
  formData.append('area', area)
  formData.append('idArticulo', idArticulo)
  formData.append('puesto', puesto)
  formData.append('codigoEmp', codigoEmp)
  formData.append('tipo', tipo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/updateResponsiva.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

ResponsivasService.updateResponsivas_Inactivas = async function (id_articulo, nombre_responsiva) {
  let formData = new FormData()
  formData.append('idart', id_articulo)
  formData.append('nresp', nombre_responsiva)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/updateResponsivas_Inactivas.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

ResponsivasService.updateResponsivas_InactivasMultiple = async function (id_usuario, nombre_responsiva) {
  let formData = new FormData()
  formData.append('idu', id_usuario)
  formData.append('nresp', nombre_responsiva)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/updateResponsivas_InactivasMult.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

ResponsivasService.addItems_Computo = async function (idResponsiva, id_computo, color, capacidad, memoria, cargador, backpack, caja, mouse, funda, accesorios) {
  let formData = new FormData()
  formData.append('idResponsiva', idResponsiva)
  formData.append('id_computo', id_computo)
  formData.append('color', color)
  formData.append('capacidad', capacidad)
  formData.append('memoria', memoria)
  formData.append('cargador', cargador)
  formData.append('backpack', backpack)
  formData.append('caja', caja)
  formData.append('mouse', mouse)
  formData.append('funda', funda)
  formData.append('accesorios', accesorios)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/addItems_computo.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

ResponsivasService.deleteItems_Forms = async function (nombreResponsiva, form) {
  formData.append('nR', nombreResponsiva)
  formData.append('f', form)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/deleteItems_Forms.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

ResponsivasService.addItems_Telefono = async function (idResponsiva, id_telefono, modelo, capacidad, color, numero, imei, serieSim, min, sms, plan, cargador, audifonos, caja, sim, protector, adaptador) {
  let formData = new FormData()
  formData.append('idResponsiva', idResponsiva)
  formData.append('id_telefono', id_telefono)
  formData.append('modelo', modelo)
  formData.append('capacidad', capacidad)
  formData.append('color', color)
  formData.append('numero', numero)
  formData.append('imei', imei)
  formData.append('serieSim', serieSim)
  formData.append('min', min)
  formData.append('sms', sms)
  formData.append('plan', plan)
  formData.append('cargador', cargador)
  formData.append('audifonos', audifonos)
  formData.append('caja', caja)
  formData.append('sim', sim)
  formData.append('adaptador', adaptador)
  formData.append('protector', protector)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/addItems_telefono.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

ResponsivasService.addItems_Combustible = async function (idResponsiva, idTarjeta, numeroTarjeta) {
  let formData = new FormData()
  formData.append('idResponsiva', idResponsiva)
  formData.append('idTarjeta', idTarjeta)
  formData.append('numeroTarjeta', numeroTarjeta)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/addItems_combustible.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

ResponsivasService.addItems_Peaje = async function (idResponsiva, idPeaje, estatus, dispositivo) {
  let formData = new FormData()
  formData.append('idResponsiva', idResponsiva)
  formData.append('idPeaje', idPeaje)
  formData.append('estatus', estatus)
  formData.append('dispositivo', dispositivo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/addItems_peaje.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

ResponsivasService.addItems_Vehiculo = async function (resp) {
  let formData = new FormData()
  formData.append('idResponsiva', resp.idResponsiva)
  formData.append('idVehiculo', resp.idVehiculo)
  formData.append('categoria', resp.categoria)
  formData.append('year', resp.year)
  formData.append('numeroMotor', resp.numeroMotor)
  formData.append('color', resp.color)
  formData.append('placas', resp.placas)
  formData.append('serie', resp.serie)
  formData.append('gasolina', resp.gasolina)
  formData.append('estatus', resp.estatus)
  formData.append('aseguradora', resp.aseguradora)
  formData.append('poliza', resp.poliza)
  formData.append('cobertura', resp.cobertura)
  formData.append('vencimiento', resp.vencimiento)
  formData.append('observaciones', resp.observaciones)

  formData.append('antenaRadio', resp.antenaRadio)
  formData.append('batea', resp.batea)
  formData.append('bedliner', resp.bedliner)
  formData.append('birlos', resp.birlos)
  formData.append('bolsa', resp.bolsa)
  formData.append('cablesCor', resp.cablesCor)
  formData.append('calaveras', resp.calaveras)
  formData.append('cinturonesSeg', resp.cinturonesSeg)
  formData.append('controlApert', resp.controlApert)
  formData.append('cristales', resp.cristales)
  formData.append('defensas', resp.defensas)
  formData.append('emblemaD', resp.emblemaD)
  formData.append('emblemaT', resp.emblemaT)
  formData.append('encendedor', resp.encendedor)
  formData.append('espejoInt', resp.espejoInt)
  formData.append('espejoLD', resp.espejoLD)
  formData.append('espejoLI', resp.espejoLI)
  formData.append('extintor', resp.extintor)
  formData.append('faros', resp.faros)
  formData.append('hojalateria', resp.hojalateria)
  formData.append('gato', resp.gato)
  formData.append('limpiadores', resp.limpiadores)
  formData.append('llanta', resp.llanta)
  formData.append('llantas', resp.llantas)
  formData.append('llave', resp.llave)
  formData.append('llaveCruz', resp.llaveCruz)
  formData.append('llaveTaponComb', resp.llaveTaponComb)
  formData.append('manija', resp.manija)
  formData.append('manual', resp.manual)
  formData.append('medallon', resp.medallon)
  formData.append('molduras', resp.molduras)
  formData.append('motor', resp.motor)
  formData.append('parabrisas', resp.parabrisas)
  formData.append('pintura', resp.pintura)
  formData.append('placaD', resp.placaD)
  formData.append('placaT', resp.placaT)
  formData.append('polizaV', resp.polizaV)
  formData.append('portaPD', resp.portaPD)
  formData.append('portaPT', resp.portaPT)
  formData.append('radio', resp.radio)
  formData.append('reflejantes', resp.reflejantes)
  formData.append('rines', resp.rines)
  formData.append('tapaCBatea', resp.tapaCBatea)
  formData.append('tapetes', resp.tapetes)
  formData.append('taponAceite', resp.taponAceite)
  formData.append('taponRueda', resp.taponRueda)
  formData.append('taponGas', resp.taponGas)
  formData.append('taponRadiador', resp.taponRadiador)
  formData.append('tarjetaCirc', resp.tarjetaCirc)
  formData.append('varillaAceite', resp.varillaAceite)
  formData.append('verificacion', resp.verificacion)
  formData.append('vestiduras', resp.vestiduras)
  formData.append('viceras', resp.viceras)
  

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/addItems_vehiculo.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

ResponsivasService.addItems_Multiples = async function (idResponsiva, idArticulo) {
  let formData  = new FormData()
  formData.append('idResponsiva', idResponsiva)
  formData.append('idArticulo', idArticulo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addEmplazamiento.php'
    url: '/servidores/inventario/responsivas/addItems_multiples.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

ResponsivasService.firmar = async function (id, firma, nombreFile, estado, quien, fechaFirma) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('firma', firma)
  formData.append('nombreFile', nombreFile)
  formData.append('estado', estado)
  formData.append('q', quien)
  formData.append('f', fechaFirma)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addEmplazamiento.php'
    url: '/servidores/inventario/responsivas/addFirmaResponsiva.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

ResponsivasService.update_Firma = async function (id, firma, nombreFile, estado, quien, fechaFirma) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('firma', firma)
  formData.append('nombreFile', nombreFile)
  formData.append('estado', estado)
  formData.append('q', quien)
  formData.append('f', fechaFirma)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addEmplazamiento.php'
    url: '/servidores/inventario/responsivas/updateFirmaResponsiva.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

ResponsivasService.getItems_Computo = async function (nR) {
  let formData = new FormData()
  formData.append('nR', nR)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/getItems_Computo.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ResponsivasService.getItems_Telefono = async function (nR) {
  let formData = new FormData()
  formData.append('nR', nR)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/getItems_Telefono.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ResponsivasService.getItems_Combustible = async function (nR) {
  let formData = new FormData()
  formData.append('nR', nR)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/getItems_Combustible.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ResponsivasService.getItems_Peaje = async function (nR) {
  let formData = new FormData()
  formData.append('nR', nR)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/getItems_Peaje.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ResponsivasService.getItems_Vehiculos = async function (nR) {
  let formData = new FormData()
  formData.append('nR', nR)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/getItems_Vehiculos.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ResponsivasService.borrarResponsiva = async function (idResp) {
  let formData = new FormData()
  formData.append('id', idResp)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/deleteResponsiva.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

ResponsivasService.obtenerPolizas = async function (nR) {
  const data = await bdServices.get(`/servidores/inventario/responsivas/obtenerPolizas.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ResponsivasService.deleteItems_responsiva = async function (idResp, tipo) {
  let formData = new FormData()
  formData.append('idResp', idResp)
  formData.append('tipo', tipo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/deleteItems_vehiculo.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

ResponsivasService.createExcelResponsivas = async function () {
  let formData = new FormData()
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/reportesApp/server/excel/responsivas_create.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

ResponsivasService.borrarFile = async function(nameFile) {
  const data = await bdServices.get(`/reportesApp/server/excel/borrarInventario_User.php?nameFile=${nameFile}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

ResponsivasService.updateEntregaResponsiva = async function (idResp, idUser, usuario) {
  let formData = new FormData()
  formData.append('idResp', idResp)
  formData.append('idUser', idUser)
  formData.append('usuario', usuario)
  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/inventario/responsivas/updateEntregaResponsiva.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

export default ResponsivasService


// WEBPACK FOOTER //
// ./src/services/inventario/responsivas.js